/* eslint-disable no-console */
import React from 'react';
import {
  Area,
  CartesianGrid,
  ComposedChart,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';

import {formatNumber} from '../../../pages/netZero/utils/commonFunctions';
import {divideIntoSixParts} from '../BarChart/utils/commonFunctions';

import CompositeTooltipLabel from './utils/CompositeTooltipLabel';
import DotRender from './utils/DotRender';

const CompositeAreaLineChart: React.FC<{
  data: any[];
  mainData: any;
  type?: 'composite' | 'compositeStraight' | 'lineWithoutArea';
}> = ({data, mainData, type = 'composite'}) => {
  if (
    data?.every((item: any) => {
      return item?.value === 0 || typeof item?.value !== 'number';
    })
  ) {
    data = [];
  }
  const checkMax = Math.ceil(Math.max(...data.map((item) => item.value)) * 1.2);

  const max = Number.isFinite(checkMax) ? checkMax : 100;
  const divideIntoSix = divideIntoSixParts(max);
  const divideIntoSixFormat = divideIntoSixParts(max).map((item) => {
    return `${formatNumber(item)} ${data?.[0]?.unit ?? ''}`.length;
  });

  const color = mainData?.fill;

  return divideIntoSix.every((item) => {
    return item >= 0;
  }) ? (
    <ResponsiveContainer width="100%" height="100%">
      <ComposedChart
        width={500}
        height={400}
        data={data}
        // margin={{
        //   top: 20,
        //   right: 80,
        //   bottom: 20,
        //   left: 20
        // }}
      >
        {type !== 'lineWithoutArea' && (
          <defs>
            <linearGradient id="colorUv" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor={color} />
              <stop offset="100%" stopColor="#ffffff" />
            </linearGradient>
          </defs>
        )}
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis
          dataKey="source"
          axisLine={false}
          tickLine={false}
          label={{position: 'insideBottomRight'}}
          padding={{left: 60, right: 60}}
        />
        <YAxis
          axisLine={false}
          tickLine={false}
          unit={` ${data?.[0]?.unit ?? ''}`}
          domain={[0, max]}
          style={{font: 'normal normal 400 12px/15px Montserrat'}}
          ticks={divideIntoSix}
          width={Math.max(...divideIntoSixFormat) * 7}
          tickFormatter={(value) => {
            return formatNumber(value);
          }}
        />
        <Tooltip
          cursor={{
            stroke: color,
            strokeWidth: 2,
            strokeDasharray: '5 5'
          }}
          content={<CompositeTooltipLabel />}
        />
        {type !== 'lineWithoutArea' && (
          <Area
            type={type === 'composite' ? 'monotone' : undefined}
            dataKey="value"
            stroke="url(#colorUv)"
            fill="url(#colorUv)"
          />
        )}
        <Line
          type={type === 'composite' ? 'monotone' : undefined}
          dataKey="value"
          stroke={color}
          strokeWidth={5}
          activeDot={(props: any) => <DotRender payload={props} />}
        />
      </ComposedChart>
    </ResponsiveContainer>
  ) : (
    <></>
  );
};

export default CompositeAreaLineChart;
